import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { NewAccountStackRoutes, NewAccountStackScreenProps } from './type';
import { NewAccountWebZeroScreen } from './NewAccountWebZero.screen';
import { NewAccountNativeZeroScreen } from './NewAccountNativeZero.screen';

export const NewAccountMain: React.FC<NewAccountStackScreenProps<NewAccountStackRoutes.Main>> = ({ navigation, route }) => {
  const { onLayout, onData, func, onReturnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <NewAccountNativeZeroScreen
        onClose={onGoBack}
        onLayout={onLayout}
        onData={onData}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
      />
    );
  }

  return (
    <NewAccountWebZeroScreen
      onClose={closeModal}
      onLayout={onLayout}
      onData={onData}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
    />
  );
};
